import namespace from 'application/nm';
let { info, log, warn, error, } = require('./console');
import { getLastWordFromCamelCase, } from 'utils/string';
import { create as makeEmptyObj, classFactory, } from 'utils/object';


const MUST_OVERRIDE_METHOD_ERROR_MESSAGE = 'Must implement this method in subclass';

function addCurriedConsoleMethod(curriedMethods, method){
  curriedMethods[method.methodName] = method.curry(`[${ this.constructor.name }]`);
  return curriedMethods;
}

function curryConsoleMethods(...consoleMethods){
  // I have no idea why, but calling Array.from(...consoleMethods)
  // didn't work and Array.from(arguments) does.
  return Array.from(arguments).reduce(
    addCurriedConsoleMethod.bind(this),
    makeEmptyObj()
  );
}

export default class BaseClass {

  static get ['MUST_OVERRIDE_METHOD_ERROR_MESSAGE'](){
    return MUST_OVERRIDE_METHOD_ERROR_MESSAGE;
  }

  get DEFAULTS(){
    return makeEmptyObj();
  }

  constructor(options = {}){
    this.merge(
      curryConsoleMethods.call(this, info, log, warn, error),
      { options, }
    );

    let { constructor, } = this;
    let className = constructor.name;
    let baseClassNamePlural = `${ getLastWordFromCamelCase(className) }s`;
    let baseClassNamePluralLower = baseClassNamePlural.toLowerCase();
    // Register classes in namespace
    let classes = namespace.classes = namespace.classes || makeEmptyObj();
    classes[baseClassNamePlural] = classes[baseClassNamePlural] || makeEmptyObj();
    classes[baseClassNamePlural][className] = constructor;
    // Register instances in namespace
    let instances = namespace.instances = namespace.instances || makeEmptyObj();
    instances[baseClassNamePluralLower] = instances[baseClassNamePluralLower] || new WeakSet();
    instances[baseClassNamePluralLower].add(this);
  }

  merge(...sources){
    Object.assign(this, ...sources);
    return this;
  }

  static create(...args){
    return classFactory(this).create(...args);
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/BaseClass.js